module.exports = __webpack_public_path__ + "media/packs/site/assets/images/close_icon-42aad32460ca90b85fb5a63278cad358.svg";